import { IOrganization } from '../common/organization/interfaces';
import { localStorageWrapper } from './localStorage';

export const needToUseSsn = (inputOrganization?: IOrganization) => {
  const organization =
    inputOrganization || localStorageWrapper.getOrganization();
  if (!organization) {
    return true;
  }
  return !(organization.name === 'J.B. HUNT');
};
